module.exports = __webpack_public_path__ + "static/media/transactionSuccessIcon.55d5dda4.svg";